module.exports = __webpack_public_path__ + "static/media/icons8-trash.b1810b14.svg";